function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOhneWasserAnwendbar = function SvgOhneWasserAnwendbar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.53 94.42"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70.28 46.27 44.17 2.21c-.35-.59-1.02-.96-1.73-.96s-1.38.37-1.73.97L14.59 46.27c-5.8 9.78-5.8 21.46 0 31.25 5.81 9.8 16.22 15.65 27.85 15.65s22.04-5.85 27.85-15.65c5.8-9.78 5.8-21.46 0-31.25Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39 7.43.36 89.17l-.36.35 3.14 3.32L89.17 11.1l.36-.34z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgOhneWasserAnwendbar;